import '.c3{flex-shrink:0;}.ssr-plugin'
import '.c4{padding:1rem;}.ssr-plugin'
import '.a2{width:100%;}.ssr-plugin'
import '.bl{height:100%;}.ssr-plugin'
import '.b9{border:none;}.ssr-plugin'
import '.ba{background-color:transparent;}.ssr-plugin'
import '.fg{border-radius:0px;}.ssr-plugin'
import '.i{display:flex;}.ssr-plugin'
import '.j{flex-direction:column;}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.d8{position:sticky;}.ssr-plugin'
import '.fh{top:4rem;}.ssr-plugin'
import '.fi{z-index:7;}.ssr-plugin'
import '.ae{background-color:var(--shades-white);}.ssr-plugin'
import '.fj{padding-bottom:1rem;}.ssr-plugin'
import '.a7{margin-bottom:1rem;}.ssr-plugin'
import '.fk{border-bottom:var(--blue-border);}.ssr-plugin'
import '.a0{position:fixed;}.ssr-plugin'
import '.cx{top:0;}.ssr-plugin'
import '.bj{left:0px;}.ssr-plugin'
import '.bk{right:0px;}.ssr-plugin'
import '.fl{bottom:0px;}.ssr-plugin'
import '.fa{z-index:9999;}.ssr-plugin'
import '.fm{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.cw{justify-content:flex-end;}.ssr-plugin'
import '.c5{flex:1;}.ssr-plugin'
import '.ar{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { Button } from '@app/components/core/button/Button'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="c3 c4 a2 bl b9 ba fg"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="i j ab"
    >
      <div className="d8 fh fi ae fj a7 fk i"
      >
        <Button
          variant="link"
          label={collapsedButtonLabel}
          onClick={() => setIsOpen(true)}
        />
      </div>

      <div className="a0 cx bj bk fl fa ae fm i j"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="c4 i cw fk"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="c5 ar">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
